import { render, staticRenderFns } from "./DossierBrowseExtraButtons.vue?vue&type=template&id=442d983c&"
import script from "./DossierBrowseExtraButtons.vue?vue&type=script&lang=ts&"
export * from "./DossierBrowseExtraButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('442d983c')) {
      api.createRecord('442d983c', component.options)
    } else {
      api.reload('442d983c', component.options)
    }
    module.hot.accept("./DossierBrowseExtraButtons.vue?vue&type=template&id=442d983c&", function () {
      api.rerender('442d983c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dossier/DossierBrowseExtraButtons.vue"
export default component.exports